import { render } from 'react-dom';
import App from 'app/App';

import './assets/css/tailwind.css';

render(<App />, document.getElementById('root'));
